import * as React from 'react';

function SvgPencilOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeWidth: 1.6, d: "M12.72 6.579L2.792 16.857 2 21.999l5.239-.551 9.97-10.323-4.49-4.546zM17.096 2.198l-2.14 2.14 4.706 4.706 2.14-2.14a.674.674 0 000-.955L18.05 2.198a.675.675 0 00-.954 0z" })));
}

export default SvgPencilOutline;
